import { createAsyncThunk } from '@reduxjs/toolkit';

import request from '../../modules/Request/request';

export const getVersions = createAsyncThunk(
  'getVersions',
  async (object, { rejectWithValue }) => {
    const response = await request('/version-breakdown', { method: 'GET', query: { pkgId: object.pkgId } });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getEditions = createAsyncThunk(
  'getEditions',
  async (object, { rejectWithValue }) => {
    const response = await request('/edition-breakdown', { method: 'GET' });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getVersionKpiScore = createAsyncThunk(
  'getVersionKpiScore',
  async (object, { rejectWithValue }) => {
    const response = await request('/version-kpi-score/account', { method: 'GET', query: { pkgId: object.pkgId } });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
